import { UsurpPricingHistogramDataProvider } from 'site-modules/shared/components/inventory/usurp-histogram/usurp-pricing-histogram-data-provider';

export const usurpDependencyContextValue = { filters: { histogram: { component: UsurpPricingHistogramDataProvider } } };
